var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33331 14.6666H2.66663C2.30935 14.679 1.96295 14.5426 1.71016 14.2898C1.45737 14.037 1.32088 13.6906 1.3333 13.3333V6.66663C1.32088 6.30935 1.45737 5.96295 1.71016 5.71016C1.96295 5.45737 2.30935 5.32088 2.66663 5.3333H5.3333V2.66663C5.32088 2.30935 5.45737 1.96295 5.71016 1.71016C5.96295 1.45737 6.30935 1.32088 6.66664 1.3333H13.3333C13.6906 1.32088 14.037 1.45737 14.2898 1.71016C14.5426 1.96295 14.679 2.30935 14.6666 2.66663V9.33329C14.6788 9.69049 14.5423 10.0368 14.2896 10.2896C14.0368 10.5423 13.6905 10.6788 13.3333 10.6666H10.6666V13.3333C10.6788 13.6905 10.5423 14.0368 10.2896 14.2896C10.0368 14.5423 9.69051 14.6788 9.33331 14.6666ZM2.66663 6.66663V13.3333H9.33331V10.6666H6.66664C6.3094 10.6788 5.96313 10.5423 5.71038 10.2896C5.45763 10.0368 5.32108 9.69049 5.3333 9.33329V6.66663H2.66663ZM6.66664 2.66663V9.33329H13.3333V2.66663H6.66664Z",
    fill: "url(#paint0_linear_1303_3701)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1303_3701",
    x1: 0.272119,
    y1: 7.94298,
    x2: 16.7301,
    y2: 7.94298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228829,
    stopColor: "#37C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560256,
    stopColor: "#8572DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF45EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9811f3894acd7f847cc663ca9cc3f482.svg";
export { ForwardRef as ReactComponent };